export const getSafeLoginRedirectUrl = (
  redirectUrl: string | undefined,
  siteUrl: string
) => {
  try {
    const siteOrigin = new URL(siteUrl).origin;
    const homeUrl = `${siteOrigin}/`;
    const targetUrl = new URL(redirectUrl || homeUrl, homeUrl);
    return targetUrl.origin === siteOrigin ? targetUrl.toString() : homeUrl;
  } catch {
    return '/';
  }
};

export const buildMobileLoginUrl = ({
  redirectUrl,
  siteUrl,
  coralAppId,
  beaconId,
  baseUrl = '',
  query = {},
}: {
  redirectUrl?: string;
  siteUrl: string;
  coralAppId: string;
  beaconId?: string;
  baseUrl?: string;
  query?: Record<string, string>;
}) => {
  const searchParams = new URLSearchParams({
    ...query,
    s_appid: coralAppId,
    s_beacon: beaconId || '',
    s_url: getSafeLoginRedirectUrl(redirectUrl, siteUrl),
  });
  return `${baseUrl}/embed/page/mobile/login.html?${searchParams.toString()}`;
};

// 获取手机号登录链接地址
export default function useMobileLogin({
  redirectUrl,
  coralAppId,
  baseUrl = '',
  query = {},
}: {
  redirectUrl?: string;
  coralAppId: string;
  baseUrl?: string;
  query?: { [key: string]: string };
}) {
  const beaconId = process.env.NEXT_PUBLIC_DATONG_ID;
  const siteUrl =
    (typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_APP_SERVER_URL) || '/';
  const url =
    redirectUrl ||
    (typeof window !== 'undefined'
      ? window?.location.href
      : process.env.NEXT_PUBLIC_APP_SERVER_URL) ||
    '/';
  return buildMobileLoginUrl({
    redirectUrl: url,
    siteUrl,
    coralAppId,
    beaconId,
    baseUrl,
    query,
  });
}
